import { EXTERNAL_PREFIXES } from './link.constants';

type ExternalPrefix = (typeof EXTERNAL_PREFIXES)[number];
export const isExternalUrl = (
  url: string,
): url is `${ExternalPrefix}${string}` =>
  EXTERNAL_PREFIXES.some((prefix) => url.startsWith(prefix));
